var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.1333C16.5 4.99105 13.1422 1.6333 9 1.6333C4.85775 1.6333 1.5 4.99105 1.5 9.1333C1.5 13.2756 4.85775 16.6333 9 16.6333",
    stroke: "#222222",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75016 1.67041C9.75016 1.67041 12.0002 4.63291 12.0002 9.13291M8.25016 16.5954C8.25016 16.5954 6.00016 13.6329 6.00016 9.13291C6.00016 4.63291 8.25016 1.67041 8.25016 1.67041M1.97266 11.7579H9.00016M1.97266 6.50791H16.0277",
    stroke: "#222222",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4094 13.571C16.7799 13.799 16.7566 14.3533 16.3756 14.3968L14.4504 14.615L13.5871 16.349C13.4161 16.6933 12.8874 16.5245 12.7996 16.0985L11.8584 11.5115C11.7841 11.1515 12.1081 10.925 12.4209 11.1178L16.4094 13.571Z",
    stroke: "#222222",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.fec7b3eea7e4421a7081e0e3bda90e2c.svg";
export { ForwardRef as ReactComponent };